<template>
  <b-modal id="modal-view-sms" footer-class="justify-content-start" size="xl">
    <template v-slot:modal-title>
      <h4 class="p-3 mb-0 font-weight-boldy">View SMS</h4>
    </template>
    <b-container fluid>
      <b-row class="mb-3">
        <b-col
          v-if="message && message.smsBody"
          cols="12"
          style="white-space: pre-wrap"
        >
          <code>{{ message.smsId }}</code>
          <hr />
          <p>{{ message.smsBody }}</p>
        </b-col>
      </b-row>
    </b-container>
    <template v-slot:modal-footer="{ cancel }">
      <R-Button :size="'small'" @onClick="cancel()">Close</R-Button>
    </template>
  </b-modal>
</template>
<script>
export default {
  name: "ModalViewSms",
  props: {
    message: {
      required: true,
    },
  },
};
</script>
